<template>
  <van-tabs color="#035F92" title-active-color="#035F92" title-inactive-color="#999999" :ellipsis="false" v-model="name" ref="tabs">
    <van-tab
      v-for="item in menu"
      :name="item.name"
      :class="item.children && item.children.length ? '' : 'hide'"
      :title="item.meta.title"
      :key="item.name"
      :to="item.path"
    >
      <template v-if="item.children">
        <SubNav
          :menu="item.children"
          :flexInherit="item.children.length < 5"
          v-if="item.meta.id != 3091831 && item.meta.id != 3091833 && item.meta.id != 3091836"
        />
      </template>
    </van-tab>
  </van-tabs>
</template>

<script>
import SubNav from "@/components/SubNav";
export default {
  name: "NavCom",
  props: {
    menu: {
      type: Array,
      defaule: () => [],
    },
  },
  components: {
    SubNav,
  },
  data() {
    return {
      name: "",
    };
  },
  created() {
    setTimeout(() => {
      this.$refs.tabs.resize();
    }, 1000);
  },
  methods: {},
  watch: {
    $route(val) {
      this.name = val.name;
      document.title = "中证网 - " + val.meta.title;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
